module.exports = __webpack_public_path__ + "static/media/beep.ee628726.mp3";